import axiosInstance from '../../../constants/axiosInstance';
import {
    Asset,
    ConfiguredTemplate,
    Configuration,
    OcrDataResponse,
} from '../types/dataInputTypes';

export const fetchAssets = async (searchQuery: string): Promise<Asset[]> => {
    const response = await axiosInstance().get('/ocr/getListOfAssetsAutoComplete', {
        params: { searchQuery },
    });
    return response.data.data;
};

export const fetchConfiguredTemplates = async (
    searchQuery: string,
    assetId: string | null
): Promise<ConfiguredTemplate[]> => {
    const payload = {
        searchQuery,
        assetIds: assetId ? [assetId] : [],
    };
    const response = await axiosInstance().post('/ocr/getListOfLogbookAssetConfigurations', payload);
    return response.data.data;
};

export const processImageForData = async (
    imageData: File,
    logbookAssetConfigurationId: string,
    assetId: string,
    logbookTemplateId: string,
    signal: AbortSignal
): Promise<OcrDataResponse> => {
    const formData = new FormData();
    formData.append('imageInput', imageData);
    formData.append('logbookAssetConfigurationId', logbookAssetConfigurationId);
    formData.append('assetId', assetId);
    formData.append('logbookTemplateId', logbookTemplateId);

    const response = await axiosInstance().post('/ocr/processOCRInput', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        signal,
    });
    return response.data;
};

export const fetchProcessedImage = async (
    data: any,
    signal: AbortSignal
): Promise<{ imageUrl: string }> => {
    const response = await axiosInstance().post(
        '/ocr/getImageSnippet',
        { imageId: data.imageId, dataInputId: data.dataInputId },
        {
            signal,
            responseType: 'arraybuffer',
        }
    );

    const blob = new Blob([response.data], { type: 'image/png' });
    const url = URL.createObjectURL(blob);

    return { imageUrl: url };
};

export const saveExtractedData = async (payload: {
    dataInputId: string;
    configurations: Configuration[];
    logbookTimestamp: number;
}): Promise<{ message: string }> => {
    const response = await axiosInstance().post('/ocr/saveDataInDISensors', payload);
    return response.data;
};

